// extracted by mini-css-extract-plugin
export default {"wrap":"xF-z","fullWidth":"yF-z","hideOnDesktop":"zF-z","content":"AF-z","hasOpenedNav":"BF-z","crumbsList":"CF-z","dropdownsWrap":"DF-z"};